import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PortableWifiOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"portable_wifi_off"}/>
}
